import classes from './fieldByType.module.css';

import TextareaAutosize from 'react-textarea-autosize';

const TextStringTypeField = ({
  item,
  selectItem,
  setNewSelectItem,
  fromOther,
  forTable,
  disabled,
}) => {

  if (forTable) {
    const formatDateIfNeeded = (value) => {
      if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}Z$/.test(value)) {
        try {
          const date = new Date(value);
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, '0');
          const day = String(date.getDate()).padStart(2, '0');
          const hours = String(date.getHours()).padStart(2, '0');
          const minutes = String(date.getMinutes()).padStart(2, '0');
          const seconds = String(date.getSeconds()).padStart(2, '0');
          return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
        } catch (e) {
          return value;
        }
      }
      return value;
    };

    const getDisplayValue = () => {
      if (item == null) return ' ';

      if (typeof item === 'string') {
        const formattedItem = formatDateIfNeeded(item);
        return formattedItem !== '/' ? formattedItem : ' ';
      }
      if (fromOther) {
        return item.value != null && item.value !== '/' ? item.value : ' ';
      }
      return item.value?.text ?? (item.value != null && item.value !== '/' ? item.value : ' ');
    };

    return <div>{getDisplayValue()}</div>;
  }
  return (
    <TextareaAutosize
      className={classes.input}
      value={selectItem?.value}
      onChange={({ target: { value } }) => {
        setNewSelectItem({ value: `${value}` ?? ' ', setting: {} });
      }}
      disabled={disabled}
    />
  );
};

export default TextStringTypeField;
